const LOCAL_API_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);
const BOTSPOT_FRONTEND_HOSTS = new Set(['botspot.trade', 'www.botspot.trade', 'dev.botspot.trade']);
const BOTSPOT_HOSTED_API_HOSTS = new Set(['api.botspot.trade', 'api.dev.botspot.trade']);
const DEV_API_URL = 'https://api.dev.botspot.trade';
const PRODUCTION_API_URL = 'https://api.botspot.trade';
const LOCAL_API_URL = 'https://localhost:8082';

const isLocalHostname = (hostname) =>
  LOCAL_API_HOSTS.has(hostname) || Boolean(hostname?.endsWith('.localhost'));

export const isLocalApiUrl = (value) => {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return isLocalHostname(parsed.hostname);
  } catch {
    return false;
  }
};

export const isHostedHostname = (hostname) => Boolean(hostname && !isLocalHostname(hostname));

export const isHostedFrontendUrl = (value) => {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return BOTSPOT_FRONTEND_HOSTS.has(parsed.hostname);
  } catch {
    return false;
  }
};

export const isBotspotHostedApiUrl = (value) => {
  if (!value) return false;
  try {
    return BOTSPOT_HOSTED_API_HOSTS.has(new URL(value).hostname);
  } catch {
    return false;
  }
};

export const getApiBaseUrl = (options = {}) => {
  const configured = Object.prototype.hasOwnProperty.call(options, 'configured')
    ? options.configured
    : process.env.REACT_APP_API_URL;
  const allowHostedDevApiOnLocalhost = Object.prototype.hasOwnProperty.call(
    options,
    'allowHostedDevApiOnLocalhost',
  )
    ? options.allowHostedDevApiOnLocalhost === true
    : process.env.REACT_APP_ALLOW_HOSTED_DEV_API_ON_LOCALHOST === 'true';
  const hostname = Object.prototype.hasOwnProperty.call(options, 'hostname')
    ? options.hostname
    : window.location?.hostname;

  if (!hostname) {
    return (configured || '').replace(/\/$/, '');
  }

  if (!isHostedHostname(hostname)) {
    if (
      allowHostedDevApiOnLocalhost &&
      String(configured || '').replace(/\/$/, '') === DEV_API_URL
    ) {
      return DEV_API_URL;
    }
    if (!configured || isBotspotHostedApiUrl(configured)) {
      return LOCAL_API_URL;
    }
    return configured.replace(/\/$/, '');
  }

  const configuredLooksWrongForHostedSite =
    isLocalApiUrl(configured) || isHostedFrontendUrl(configured);

  if (configured && !configuredLooksWrongForHostedSite) {
    return configured.replace(/\/$/, '');
  }

  if (hostname === 'dev.botspot.trade') {
    return DEV_API_URL;
  }
  return PRODUCTION_API_URL;
};

export default getApiBaseUrl;
